<template>
  <el-dialog :visible.sync="visible" width="700px" title="打赏记录" @close="handleClose" append-to-body :close-on-click-modal="false">
    <div class="reward-summary">
      <div class="summary-item">
        <div class="summary-label">打赏人数(人)</div>
        <div class="summary-value">{{ summary.people || 0}}</div>
      </div>
      <div class="summary-item">
        <div class="summary-label">打赏次数(次)</div>
        <div class="summary-value">{{ summary.times || 0}}</div>
      </div>
      <div class="summary-item">
        <div class="summary-label">现金打赏(元)</div>
        <div class="summary-value">{{ summary.cash || 0}}</div>
      </div>
      <div class="summary-item">
        <div class="summary-label">零售价打赏(币)</div>
        <div class="summary-value">{{ summary.coin || 0}}</div>
      </div>
    </div>
    <div v-if="records.length" class="reward-list">
      <div v-for="(item, idx) in records" :key="idx" class="reward-item">
        <el-avatar :src="item.avatar" size="large" />
        <div class="reward-info">
          <div>
            <span class="reward-name">{{ item.name }}</span>
            <span class="reward-class">（{{ item.class }}）</span>
            <span class="reward-phone">{{ item.phone }}</span>
          </div>
          <div class="reward-date">{{ item.date }}</div>
        </div>
        <div class="reward-amount" :class="item.type">
          <img v-if="item.type === 'coin'" src="零售价图标.png" class="coin-icon" />
          <span v-if="item.type === 'coin'">{{ item.amount }}零售价</span>
          <span v-else>{{ item.amount }}元</span>
        </div>
      </div>
    </div>
    <div v-else class="empty">暂无打赏记录</div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RewardRecordDialog',
  data() {
    return {
      visible: false,
      summary: {
        people: 489,
        times: 489,
        cash: 489,
        coin: 4892
      },
      records: [
        {
          avatar: 'https://img.yzcdn.cn/vant/cat.jpeg',
          name: '杜三',
          class: '体验班',
          phone: '1456322124',
          date: '2025-02-11',
          type: 'coin', // coin 或 cash
          amount: 20
        },
        {
          avatar: 'https://img.yzcdn.cn/vant/cat.jpeg',
          name: '杜三',
          class: '体验班',
          phone: '1456322124',
          date: '2025-02-11',
          type: 'cash',
          amount: 10
        }
        // ...更多数据
      ]
    }
  },
  methods: {
    handleShow(summary = {}, records = []) {
      if (Object.keys(summary).length) this.summary = summary
      if (records.length) this.records = records
      this.visible = true
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.reward-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 16px 0;
}
.summary-item {
  flex: 1;
  text-align: center;
}
.summary-value {
  font-size: 22px;
  font-weight: bold;
  color: #222;
}
.summary-label {
  font-size: 14px;
  color: #888;
  margin-top: 4px;
}
.reward-list {
  max-height: 400px;
  overflow-y: auto;
}
.reward-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}
.reward-info {
  flex: 1;
  margin-left: 16px;
}
.reward-name {
  font-weight: bold;
  color: #222;
}
.reward-class {
  color: #888;
  margin-left: 4px;
}
.reward-phone {
  color: #888;
  margin-left: 8px;
}
.reward-date {
  color: #bbb;
  font-size: 13px;
  margin-top: 4px;
}
.reward-amount {
  min-width: 90px;
  text-align: right;
  font-size: 16px;
  font-weight: bold;
}
.reward-amount.coin {
  color: #ff4d4f;
}
.reward-amount.cash {
  color: #faad14;
}
.coin-icon {
  width: 20px;
  vertical-align: middle;
  margin-right: 4px;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
</style>